import { absolutePath } from "./absolutePath";

export const oneSchemaConfiguration = {
  retrieve: () => absolutePath("import/one_schema/configuration"),
};
